module.exports = __webpack_public_path__ + "img/perfect-money-new-version.cdd8105a.png";